import { Route, Switch } from '@treams/treams-routes';
import BulkEmployeeEdit from '../packages/kakapo-ui-settings-application/pages/bulk-employee-edit/BulkEmployeeEdit';

import CompetenciesSettings from './CompetenciesSettings';
import ConversationsSettings from './conversations/ConversationsSettings';
import CyclesSettings from './CyclesSettings';
import JobsSettings from './JobsSettings';
import LearningSettings from './LearningSettings';
import NotificationsSettings from './NotificationsSettings';
import OrganizationSettings from './OrganizationSettings';
import TalentReviewsSettings from './TalentReviewsSettings';
import WorkspacesSettings from './WorkspacesSettings';
import Billing from 'billing/Billing';

import OverviewSettings from './overview/OverviewSettings';
import EngagementSettings from '../engagement/settings/EngagementSettings';
import GoalsSettings from './GoalsSettings';
import FeedbackSettingsV2 from '../feedback/settings/FeedbackSettings';
import Connectors from '../connectors/Connectors';
import EmployeesSettings from './employees/EmployeesSettings';
import AdvancedSettings from './AdvancedSettings';
import JobPositionsSettings from './JobPositionsSettings';
import UserRolesSettings from './UserRolesSettings';

export default function Settings() {
	return (
		<Switch>
			<Route path="/settings" exact>
				<OverviewSettings />
			</Route>

			<Route path="/settings/organization">
				<OrganizationSettings />
			</Route>
			<Route path="/settings/jobs">
				<JobsSettings />
			</Route>
			<Route path="/settings/competencies">
				<CompetenciesSettings />
			</Route>
			<Route path="/settings/goals">
				<GoalsSettings />
			</Route>
			<Route path="/settings/cycles">
				<CyclesSettings />
			</Route>
			<Route path="/settings/notifications">
				<NotificationsSettings />
			</Route>
			<Route path="/settings/billing">
				<Billing />
			</Route>
			<Route path="/settings/feedback-v2">
				<FeedbackSettingsV2 />
			</Route>
			<Route path="/settings/conversations">
				<ConversationsSettings />
			</Route>
			<Route path="/settings/talent-reviews">
				<TalentReviewsSettings />
			</Route>
			<Route path="/settings/learning">
				<LearningSettings />
			</Route>
			<Route path="/settings/integrations">
				<Connectors />
			</Route>

			<Route path="/settings/engagement">
				<EngagementSettings />
			</Route>
			<Route path="/settings/bulk">
				<BulkEmployeeEdit />
			</Route>
			<Route path="/settings/workspaces">
				<WorkspacesSettings />
			</Route>
			<Route path="/settings/employees">
				<EmployeesSettings />
			</Route>
			<Route path="/settings/roles">
				<UserRolesSettings />
			</Route>
			<Route path="/settings/job-positions">
				<JobPositionsSettings />
			</Route>
			<Route path="/settings/advanced">
				<AdvancedSettings />
			</Route>
		</Switch>
	);
}
